import MetaHead from '../components/MetaHead';

export default function TestimonialsPage() {
  const testimonialsList = [
    {
      author: 'Mand',
      age: '52 år',
      quote: '"Marie, du er en dygtig håndværker indenfor dit virkefelt. Jeg har det som en gammel veteranbil som var skrottet og opgivet, men som efter en renovering af en dygtig, nænsom og ærlig håndværker igen har fået nyt liv. Og nu fremstår strømlinet i alt sin pragt og lyst til mange nye kilometer ud i den lysende fremtid".'
    },
    {
      author: 'Kvinde',
      age: '40 år',
      quote: '"Marie formår lynhurtigt at spotte, hvilket menneske man er og tager udgangspunkt i det og dig. Hun er kreativ, fagligt dygtig og et fantastisk glad, inspirerende og varmt menneske, som man ved første øjekast føler sig tryg ved. Hun vil dig kun det bedste."'
    },
    {
      author: 'Mor til datter',
      age: 'på 11 år',
      quote: '"Min datter på 11 år har været i et forløb ved Marie. Marie har en skøn og ligefrem måde at tilgå kommunikationen i børnehøjde, så min datter åbnede op og kunne arbejde med de problematikker hun kom med. Marie finder givende og konkrete veje ind, så der kan arbejdes håndgribeligt og på barnets niveau."'
    },
    {
      author: 'Mand',
      age: '31 år',
      quote: '"At gå i terapi hos dig vil jeg beskrive således: Jeg føler, det er som at have en samtale med mig selv hos en, der ikke har følelser i klemme. Og via dig får jeg stillet de spørgsmål, jeg ikke får stillet mig selv. På den måde får jeg i terapien tid og rum til refleksion. Og derudover, så er du ærlig og det gør mig tryg. Jeg ser altid frem til at snakke med dig og på svære dage tæller jeg ned til, at jeg har min næste tid hos dig”.'
    }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12">
      <MetaHead 
        title="Udtalelser - Din Privat Psykolog"
        description="Privat psykolog, 20 års erfaring, Klinisk psykolog i Syddanmark, Autoriseret psykolog med bred klinisk erfaring, Samtaleterapi med individuelle, samtaleterapi, parterapi, psykologhjælp,  "
        ogTitle="Klientudtalelser - Din Privat Psykolog"
        ogDescription="Privat psykolog, 20 års erfaring, Klinisk psykolog i Syddanmark, Autoriseret psykolog med bred klinisk erfaring, Samtaleterapi med individuelle, samtaleterapi, parterapi, psykologhjælp,  "
        ogImage="https://assets.auxodev.dk/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/61a0bb4f-47a8-4ecb-a747-8c6184fb1879_3bd59b5a.jpg"
      />

      {/* Page Header */}
      <div className="border-b border-[#E0D7C6] pb-8 space-y-3">
        <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#5f7365]">
          Udtalelser fra tidligere klienter
        </h1>
        <p className="text-base text-[#3B4D42] max-w-2xl leading-relaxed">
          Her kan du læse et udvalg af erfaringer fra mennesker, der har været i forløb i klinikken i Gram.
        </p>
      </div>

      {/* Grid of Testimonials */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {testimonialsList.map((item, index) => (
          <div 
            key={index}
            className="bg-[#5f7365] text-white p-6 sm:p-8 flex flex-col justify-between space-y-6 select-none shadow-sm"
          >
            <div className="space-y-4">
              <div className="text-[#C6A868] text-xs flex gap-1.5 items-center" aria-label="5 ud af 5 målskiver">
                {[...Array(5)].map((_, i) => (
                  <svg
                    key={i}
                    className="w-3.5 h-3.5 fill-current"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
                    <circle cx="12" cy="12" r="3.5" fill="currentColor" />
                  </svg>
                ))}
              </div>
              <p className="text-sm sm:text-base text-[#E2EAE5] leading-relaxed italic font-sans">
                {item.quote}
              </p>
            </div>

            <div className="pt-4 border-t border-white/10 flex items-center justify-between">
              <div>
                <h2 className="font-semibold text-white text-base">
                  {item.author}
                </h2>
                <p className="text-xs text-[#9BB3A5]">
                  {item.age}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <p className="text-xs text-center text-[#52685B] italic pt-2">
        Alle citater er naturally anonymiserede og videregivet efter tilladelse
      </p>
    </div>
  );
}
